import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_GET_TRANSACTIONS } from "../../../config/api";

export const autoFetchTransactions = createAsyncThunk(
  "wallet/autoFetchTransactions",
  async (currency, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_GET_TRANSACTIONS + currency,
        noRefreshToken: true,
      });
      return response?.data?.data ? response?.data?.data?.reverse() : [];
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // toast.error(msg);
      throw error;
    }
  }
);
